import { useState } from 'react'
import { HealthCardModule, SupportedLanguage } from '@estercare/ester-shared'
import styled from 'styled-components'
import { ComponentLayout } from '../../components/layouts/ComponentLayout'
import { HealthPlanCardResponse } from '../../api/ester-b2b-api/private/healthPlan/types'
import { HealthPlanCardList } from '../../components/healthPlan/healthPlanCard/HealthPlanCardList'

const mockHealthPlanCards: HealthPlanCardResponse[] = [
  {
    module: HealthCardModule.EXERCISE,
    title: 'Träning',
    language: SupportedLanguage.SWEDISH,
    content: [
      {
        title: 'Varför träning är viktigt',
        text: 'Träning är en viktig del av en hälsosam livsstil och kan ha många positiva effekter på både kroppen och sinnet. Regelbunden fysisk aktivitet stärker hjärtat, förbättrar konditionen och kan hjälpa till att minska stress och ångest.',
      },
      {
        title: 'Fördelar med regelbunden träning',
        text: 'Forskning visar att regelbunden träning kan förbättra sömn, öka energinivåer och bidra till bättre mental hälsa. Det kan också stärka immunförsvaret och minska risken för kroniska sjukdomar.',
      },
      {
        title: 'Kom igång med träning',
        text: 'Börja med små steg och hitta en aktivitet du tycker om. Det kan vara promenader, simning, cykling eller styrketräning. Det viktiga är att hitta något som passar din livsstil och som du kan hålla fast vid.',
      },
    ],
  },
  {
    module: HealthCardModule.LIFESTYLE,
    title: 'Livsstil',
    language: SupportedLanguage.SWEDISH,
    content: [
      {
        title: 'Hitta balans i vardagen',
        text: 'En hälsosam livsstil handlar om att hitta balans mellan olika aspekter av livet. Det inkluderar att ta hand om sin kropp genom rätt kost, motion och vila, men också att vårda sina relationer och sitt psykiska välmående.',
      },
      {
        title: 'Små förändringar, stor effekt',
        text: 'Små förändringar i vardagen kan göra stor skillnad för din hälsa och ditt välbefinnande. Det kan handla om att dricka mer vatten, få mer sömnm eller ta regelbundna pauser från skärmtid.',
      },
      {
        title: 'Skapa hållbara vanor',
        text: 'Fokusera på att skapa vanor som är hållbara över tid. Var snäll mot dig själv och kom ihåg att varje litet steg i rätt riktning är värt att fira.',
      },
    ],
  },
  {
    module: HealthCardModule.MENTAL_WELLBEING,
    title: 'Psykiskt välmående',
    language: SupportedLanguage.SWEDISH,
    content: [
      {
        title: 'Mental hälsa är lika viktig',
        text: 'Psykiskt välmående är lika viktigt som fysisk hälsa. Att ta hand om sitt mentala hälsa innebär att vara uppmärksam på sina känslor, hantera stress på ett hälsosamt sätt och söka stöd när det behövs.',
      },
      {
        title: 'Verktyg för mental hälsa',
        text: 'Mindfulness, meditation och regelbundna pauser kan vara effektiva verktyg för att stärka det psykiska välmåendet. Att prata med vänner, familj eller en professionell kan också göra stor skillnad.',
      },
      {
        title: 'Tecken att vara uppmärksam på',
        text: 'Var uppmärksam på tecken som långvarig nedstämdhet, ångest eller sömnproblem. Det är okej att inte må bra och det är viktigt att söka hjälp när du behöver det.',
      },
    ],
  },
]

export const HealthPlanCardsComponentLibrary = () => {
  const [expandedCard, setExpandedCard] = useState<HealthPlanCardResponse | null>(null)

  return (
    <ComponentLayout>
      <Container>
        <HealthPlanCardList
          cards={mockHealthPlanCards}
          onCardClick={setExpandedCard}
          expandedCard={expandedCard}
          onClose={() => setExpandedCard(null)}
        />
      </Container>
    </ComponentLayout>
  )
}

const Container = styled.div`
  max-width: 900px;
  margin: 0 auto;
  width: 100%;
`
